import styled from 'styled-components';

import SanityBlockRenderer from 'components/sanity-block-renderer';

export const StyledSanityBlockContent = styled(SanityBlockRenderer)`
  p {
    font-size: 14px;
    line-height: 20px;
    color: ${Styles.color.secondary};
  }
`;
